import { useState } from 'react';
import { Routes, Route } from 'react-router-dom';

import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Employee from './pages/Employee';
import Entry from './pages/Entry';
import Finance from './pages/Finance';
import History from './pages/History';

const Rider = () => {

    const [isMobileOpen, setIsMobileOpen] = useState(false);

    return (
        <>
            <div className='flex select-none' >
                <Sidebar isMobileOpen={isMobileOpen} setIsMobileOpen={setIsMobileOpen} />
                <div className={'flex-1 min-h-screen overflow-y-auto p-3 transition-all duration-300'} >
                    <Routes>
                        <Route path='/' element={<Dashboard setIsMobileOpen={setIsMobileOpen} />} />
                        <Route path='/employee' element={<Employee setIsMobileOpen={setIsMobileOpen} />} />
                        <Route path='/entry' element={<Entry setIsMobileOpen={setIsMobileOpen} />} />
                        <Route path='/finance' element={<Finance setIsMobileOpen={setIsMobileOpen} />} />
                        <Route path='/history' element={<History setIsMobileOpen={setIsMobileOpen} />} />
                    </Routes>
                </div>
            </div>
        </>
    )
}

export default Rider;